import React from 'react';
import ModalPage from '../ModalPage/ModalPage';
import { Form, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { InputLabel } from '@shoflo/polymer/components/InputLabel/InputLabel';
import { Input } from '@shoflo/polymer/components/Input/Input';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { UserValidator } from '@shoflo/polymer/validators/UserValidator/UserValidator';
import { Alert } from '@shoflo/polymer/components/Alert/Alert';
import { useForm, useFormState } from 'react-hook-form';
import ModalFooterLink from '../../../components/Links/ModalFooterLink';
import AppPaths from '../../../AppPaths';
import { extractDomain } from 'helpers/getDomain';

function SSOLoginPage({ hasError, errorMessage }) {
  const { register, handleSubmit, control } = useForm({ mode: 'all' });
  const { errors, isValid } = useFormState({ control });

  return (
    <ModalPage
      header="Welcome back! SSO sign in to Shoflo"
      footer={
        hasError ? (
          <ModalFooterLink to={AppPaths.SSOLoginPage}>
            Go back to SSO login
          </ModalFooterLink>
        ) : null
      }
    >
      <>
        {hasError && (
          <Alert
            type="failure"
            title={errorMessage.title}
            content={errorMessage.content}
          />
        )}
        {!hasError && (
          <Form
            onSubmit={handleSubmit(({ email }) => {
              const domain = extractDomain(email.toLowerCase());
              const redirectPath = `/sso/login/${domain}`;
              window.location.href = redirectPath;
            })}
          >
            <FormGroup>
              <InputLabel for="email">Email address</InputLabel>
              <Input
                id="email"
                placeholder="e.g. tim.bergling@gmail.com"
                data-testid="email-input"
                error={errors.email}
                {...register('email', {
                  required: true,
                  validate: {
                    invalid: (val) =>
                      UserValidator.email(val) || 'Uh oh! Email is invalid',
                  },
                })}
              />
            </FormGroup>
            <div className="text-center">
              <Button type="submit" disabled={!isValid}>
                Sign in
              </Button>
            </div>
          </Form>
        )}
      </>
    </ModalPage>
  );
}

SSOLoginPage.propTypes = {
  hasError: PropTypes.bool,
  errorMessage: PropTypes.object,
};

export default SSOLoginPage;
